import { render } from "./SwLayout.vue?vue&type=template&id=f13702ca"
import script from "./SwLayout.vue?vue&type=script&lang=js"
export * from "./SwLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__